import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'
import axios from 'axios'
import { format } from 'date-fns'
import { Container, Button, Message, Form, FormField, Icon, Input, Divider, Header, Table, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell, Pagination, Confirm } from 'semantic-ui-react'

const Settings = () => {
    const [userID, setUserID] = useState('')
    const [serverID, setServerID] = useState('')
    const [itemsPerPage] = useState(20)
    const [activePage, setActivePage] = useState(0)
    const [fxRateMarkUp, setFxRateMarkUp] = useState('')
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)
    const [showSuccessMessageAddUser, setShowSuccessMessageAddUser] = useState(false)
    const [yahooRate, setYahooRate] = useState(0)
    const [innerWidth] = useState(window.innerWidth)
    const [restrictedMLBBUsers, setRestrictedMLBBUsers] = useState([])
    const [sortDirection, setSortDirection] = useState('descending')
    const [sortColumn, setSortColumn] = useState('date')
    const [addNewRestrictedUser, setAddNewRestrictedUser] = useState(false)
    const [showDeleteConfirmationPopup, setShowDeleteConfirmationPopup] = useState(false)
    const [idToDelete, setIdToDelete] = useState(null)
    const [deleteConfirmContentString, setDeleteConfirmContentString] = useState('')
    const [formErrorContent, setFormErrorContent] = useState('')
    const [showFormError, setShowFormError] = useState(false)

    const dispatch = useDispatch()
    const user = useSelector(state => state.userAdmin)
    const settings = useSelector(state => state.settings)

    useEffect(() => {
        dispatch(actions.fetchSettings())
    }, [dispatch])

    useEffect(() => {
        if (settings) setFxRateMarkUp(settings.fxRateMarkUp || '')
    }, [settings])

    useEffect(() => {
        axios.get('/api/yahoo_finance_rate').then(res => setYahooRate(res.data.rate))
            .catch(err => alert('Fail to get Yahoo Finance rate, please try again. Error: ' + err))
        axios.get('/api/restricted_mlbb_users').then(res => setRestrictedMLBBUsers(res.data))
            .catch(err => alert('Fail to get restricted_mlbb_users, please try again. Error: ' + err))
    }, [])

    const handlePageChange = (e, { activePage }) => {
        const page = activePage - 1
        setActivePage(page)
    }
    const handleChangeMarkUp = e => {
        setShowSuccessMessage(false)
        setFxRateMarkUp(e.target.value)
    }
    const handleSort = clickedColumn => {
        if (sortColumn !== clickedColumn) {
            setSortColumn(clickedColumn)
            setSortDirection('ascending')
            setRestrictedMLBBUsers([...restrictedMLBBUsers].sort((a, b) => {
                    if (clickedColumn === 'date') return new Date(a.createdAt) - new Date(b.createdAt)
                    if (clickedColumn === 'userID') return a.userID.localeCompare(b.userID)
                    if (clickedColumn === 'serverID') return a.serverID.localeCompare(b.serverID)
                    if (clickedColumn === 'addedBy') return a.createdBy.localeCompare(b.createdBy)
                    return 0
            }))
        } else {
            setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending')
            setRestrictedMLBBUsers([...restrictedMLBBUsers].reverse())
        }
    }
    const handleAddUserClicked = () => {
        setShowSuccessMessageAddUser(false)
        setAddNewRestrictedUser(!addNewRestrictedUser)
    }
    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'userID') setUserID(value)
        if (name === 'serverID') setServerID(value)
        setShowSuccessMessageAddUser(false)
    }
    const handleSaveRestrictedUser = () => {
        if (userID === '' || serverID === '') return
        for (const user of restrictedMLBBUsers) {
            if (user.userID === userID && user.serverID === serverID) {
                setShowFormError(true)
                setFormErrorContent('This user was already added on ' + format(new Date(user.createdAt), 'd MMM yyyy, h:mm a') + ' by ' + user.createdBy)
                return
            }
        }
        setShowFormError(false)
        const dict = { createdAt: Date(), createdBy: user.name, userID, serverID }
        axios.post('/api/restricted_mlbb_user', dict).then(() => {
            axios.get('/api/restricted_mlbb_users').then(res => {
                setRestrictedMLBBUsers(res.data)
                setShowSuccessMessageAddUser(true)
                setUserID('')
                setServerID('')
            })
            .catch(err => alert('Fail to get restricted_mlbb_users, please try again. Error: ' + err))
        }).catch(err => {
            console.log('save restricted user failed with error: ' + err)
            alert('Fail to save restricted user, please try again. Error: ' + err)
        })
    }
    const handleDeleteUserClicked = (user) => {
        if (showDeleteConfirmationPopup) return
        const contentString = `Delete restricted user: ${user.userID} (${user.serverID})?`
        setIdToDelete(user._id)
        setDeleteConfirmContentString(contentString)
        setShowDeleteConfirmationPopup(true)
    }

    const handleDeleteCancel = () => {
        setShowDeleteConfirmationPopup(false)
    }
    const handleDeleteConfirm = async () => {
        await axios.delete('/api/restricted_mlbb_user/' + idToDelete)
            .then(() => {
                setShowDeleteConfirmationPopup(false)
                axios.get('/api/restricted_mlbb_users').then(res => setRestrictedMLBBUsers(res.data))
                .catch(err => alert('Fail to get restricted_mlbb_users, please try again. Error: ' + err))
            })
            .catch(err => {
                console.log(`delete admin failed with error: ${err}`)
                alert(`Failure deleting admin, please try again. Error: ${err}`)
            })
    }
    const handleSaveSettings = () => {
        const dict = { fxRateMarkUp: Number(fxRateMarkUp) }
        axios.put('/api/settings', dict).then(() => {
            setShowSuccessMessage(true)
            axios.get('/api/yahoo_finance_rate').then(res => setYahooRate(res.data.rate))
                .catch(err => alert('Fail to get Yahoo Finance rate, please try again. Error: ' + err))
        }).catch(err => {
            console.log('save settings failed with error: ' + err)
            alert('Fail to save settings, please try again. Error: ' + err)
        })
    }
    const handleLogout = () => {
        window.localStorage.setItem('verified2FA', null)
        dispatch(actions.logout(true))
    }

    const renderPagination = () => {
        if (!restrictedMLBBUsers) return null
        const pagesRequired = Math.ceil(restrictedMLBBUsers.length / itemsPerPage)
        return <Pagination size={window.innerWidth < 768 ? 'mini' : null} inverted defaultActivePage={1} totalPages={pagesRequired} siblingRange={2} onPageChange={handlePageChange}/>
    }
    const renderTableRows = () => {
        if (!restrictedMLBBUsers) return null
        const rows = []
        for (const [i, user] of restrictedMLBBUsers.entries()) {
            rows.push(<TableRow key={i}>
                    <TableCell style={{ color: 'white' }}>{user.userID}</TableCell>
                    <TableCell style={{ color: 'white' }}>{user.serverID}</TableCell>
                    <TableCell style={{ color: 'white' }}>{format(new Date(user.createdAt), 'd MMM yyyy, h:mm a')}</TableCell>
                    <TableCell style={{ color: 'white' }}>{user.createdBy}</TableCell>
                    <TableCell collapsing><Button inverted circular basic icon onClick={() => handleDeleteUserClicked(user)}><Icon inverted name="trash alternate" /></Button></TableCell>
                </TableRow>)
        }
        return rows.reverse().slice(activePage * itemsPerPage, activePage * itemsPerPage + itemsPerPage)
    }
    const renderMLBBRestrictedUsers = () => {
        return <>
            <Button size="small" inverted color='teal' onClick={handleAddUserClicked}><Icon name={addNewRestrictedUser ? 'cancel' : 'plus'}/>{addNewRestrictedUser ? 'Cancel' : 'Add New'}</Button>
            { addNewRestrictedUser ? <div style={{ border: '1px solid #666', marginTop: 20, padding: 20, borderRadius: 6 }}>
                    <h3>New Restricted User</h3>
                    <Form inverted>
                        <FormField required control={Input} label='User ID' name='userID' value={userID} placeholder='' onChange={handleChangeField} inverted className="dark-theme-input"/>
                        <FormField required control={Input} label='Server ID' name='serverID' value={serverID} placeholder='' onChange={handleChangeField} inverted className="dark-theme-input"/>
                        <Button inverted color='teal' onClick={handleSaveRestrictedUser}><Icon name='save'/>Save</Button>
                        {showFormError ? (<Message inverted negative content={formErrorContent} />) : null}
                    </Form>
                    {showSuccessMessageAddUser ? (<Message style={{ marginTop: 22 }} inverted success header="Successfully added new restricted user." />) : null}
                </div> : null}
            <Table inverted style={style} size={innerWidth < 768 ? 'small' : ''} celled striped unstackable>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell sorted={sortColumn === 'userID' ? sortDirection : null} onClick={() => handleSort('userID')}>
                        User ID <Icon name={sortColumn === 'userID' ? (sortDirection === 'ascending' ? 'sort up' : 'sort down') : 'sort'} />
                        </TableHeaderCell>
                        <TableHeaderCell sorted={sortColumn === 'serverID' ? sortDirection : null} onClick={() => handleSort('serverID')}>
                        Server ID <Icon name={sortColumn === 'serverID' ? (sortDirection === 'ascending' ? 'sort up' : 'sort down') : 'sort'} />
                        </TableHeaderCell>
                        <TableHeaderCell sorted={sortColumn === 'date' ? sortDirection : null} onClick={() => handleSort('date')}>
                        Date Added <Icon name={sortColumn === 'date' ? (sortDirection === 'ascending' ? 'sort up' : 'sort down') : 'sort'} />
                        </TableHeaderCell>
                        <TableHeaderCell sorted={sortColumn === 'addedBy' ? sortDirection : null} onClick={() => handleSort('addedBy')}>
                        Added By <Icon name={sortColumn === 'addedBy' ? (sortDirection === 'ascending' ? 'sort up' : 'sort down') : 'sort'} />
                        </TableHeaderCell>
                        <TableHeaderCell/>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {renderTableRows()}
                </TableBody>
            </Table>
            {renderPagination()}
            <Confirm inverted open={showDeleteConfirmationPopup} onCancel={handleDeleteCancel} onConfirm={handleDeleteConfirm} header="Confirmation" content={deleteConfirmContentString} cancelButton="Cancel" confirmButton="Delete"/>
            </>
    }

    const style = innerWidth > 1035 ? { marginTop: 20 } : { marginTop: 20, overflowX: 'auto', display: 'block', whiteSpace: 'nowrap' }
    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <h1 style={{ marginTop: 30, marginBottom: 30, color: 'white' }}>Settings</h1>
            <Message inverted style={{ marginBottom: 30, backgroundColor: '#1b1c1d', color: 'white', border: '1px solid #555' }} icon="dollar" header="Exchange Rate"
                        content={ 'Yahoo Finance rate USD to SGD is currently ' + yahooRate + '. Resellers will see: ' + (yahooRate - fxRateMarkUp / 100).toFixed(5) }/>
            {showSuccessMessage ? (
                <Message inverted success header="Successfully saved changes." />
            ) : null}
            <Form inverted>
                <FormField control={Input} label="Exchange Rate Mark Up (SGD cents per 1 USD)" name="fxRateMarkUp" value={fxRateMarkUp} placeholder="Mark up" onChange={handleChangeMarkUp} inverted input={<input style={{ marginTop: 6, backgroundColor: '#1b1c1d', color: 'white' }} />}/>
                <Button inverted color='teal' style={{ marginTop: 20 }} size="small" onClick={handleSaveSettings}><Icon name="save" />Save</Button>
            </Form>
            <Button inverted style={{ marginTop: 15 }} size="small" color="red" onClick={handleLogout}>Sign out</Button>
            <Divider inverted style={{ marginTop: 25, marginBottom: 20 }} horizontal><Header inverted as="h4"><Icon inverted name="ban" />Restricted Users for 'mlbb' Package</Header></Divider>
            {renderMLBBRestrictedUsers()}
        </Container>
    )
}

export default Settings